/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/require-default-props */
import React from "react";
import IcomoonReact from "icomoon-react";
import PropTypes from "prop-types";
import iconSet from "../../Assets/IcomoonSelection/selection.json";

function Icon(props) {
  const { color, size, icon, className, onClick, style } = props;
  return (
    <IcomoonReact
      className={className}
      iconSet={iconSet}
      color={color}
      size={size}
      icon={icon}
      onClick={onClick}
      style={{ cursor: "pointer", ...style }}
    />
  );
}

Icon.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  icon: PropTypes.string.isRequired,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onClick: PropTypes.func,
  style: PropTypes.object,
};

Icon.defaultProps = {
  className: "",
  color: "",
  size: "100%",
};

export default Icon;
